import { useRef } from "react";
import {
  SchemasApi,
  OrganisationsApi,
  SitesApi,
  DataApi,
  MetersApi,
} from "@solarschools/api-sdk-typescript";
import ApiClient from "@solarschools/api-sdk/dist/ApiClient";
/**
Example Usage:

// our resouce type and ID
const resourceId = 17;
const resourceType = "schemas";

// call the hook
const [Api] = useDataResource(resourceType);

//use the methods the API presents
Api.getEnergyDataFeed();
Api.getEnergyLifetimeData();
Api.getWaterDataFeed();
Api.getWaterLifetimeData();
Api.getSummary();
Api.getList();
Api.create();
Api.update();

 */

/**
 * Fetch Hook for functional Components
 *
 * @param {string} resourceType
 */
const useDataResource = (resourceType, accessToken) => {
  const config = getConfig(accessToken);

  if (!allowedResourceTypes.includes(resourceType.toLowerCase())) {
    throw new Error("Invlaid resource type supplied to useDataResource");
  }

  let apiClient;
  switch (resourceType.toLowerCase()) {
    case "schemas":
    case "schema":
      apiClient = new SchemasApi(config);
      break;
    case "organisations":
    case "organisation":
      apiClient = new OrganisationsApi(config);
      break;
    case "sites":
    case "site":
      apiClient = new SitesApi(config);
      break;
    case "data":
      apiClient = new DataApi(config);
      break;
    case "meters":
      apiClient = new MetersApi(config);
      break;
    default:
      throw new Error(
        `useDataResource has not yet implemented the ${resourceType} resource type.`
      );
  }
  const { current } = useRef(apiClient);
  return [current];
};

export const allowedResourceTypes = [
  "schemas",
  "schema",
  "organisations",
  "organisation",
  "sites",
  "site",
  "meters",
  "data",
];

export const client = () => {
  const client = ApiClient.instance;
  client.defaultHeaders = {};
  client.basePath = "https://api.solarschools.net/v1".replace(/\/+$/, "");
  return client;
};

export const getConfig = (token) => ({
  basePath: "https://api.solarschools.net/v1".replace(/\/+$/, ""),
  baseOptions: {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  },
});

export default useDataResource;



// WEBPACK FOOTER //
// ./resources/assets/js/app/hooks/useDataResource/useDataResource.js